// components/PromoBanner.jsx
// Fetches and displays currently active promotions.
// Use on Homepage and BookingWebsite.
// Shows nothing if there are no active promotions.

import React from "react";
import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import api from "../services/api";
import { formatPerthDate } from "../utils/perthTime";
import truckImg from "../images/bintruck.jpeg";
import "../style/promoBanner.css";

export default function PromoBanner() {
  const [promotions, setPromotions] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    api.get("/promotions/active")
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setPromotions(res.data);
        }
      })
      .catch(() => {});
  }, []);

  // Auto-rotate if multiple promotions
  useEffect(() => {
    if (promotions.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % promotions.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [promotions]);

  const hasPromo = promotions.length > 0;
  const promo = hasPromo ? promotions[current] : null;

  const discountLabel = promo
  ? promo.discount_type === "PERCENTAGE"
    ? `${Number(promo.discount_value)}% OFF`
    : `$${Number(promo.discount_value)} OFF`
  : null;

  const endDate = promo ? formatPerthDate(promo.end_date) : null;

  return (
    <section className="promo-section">
      <div className={`promo-grid ${!hasPromo ? "no-promo" : ""}`}>
        {/* Left Card - Discount (only if active promotion exists) */}
        {hasPromo && (
          <div className="promo-card discount-card">
            <span className="limited-offer-label">LIMITED TIME OFFER</span>
            <h2>
              {discountLabel}
              <br />
              {promo.title || "On Your Booking!"}
            </h2>
            <p>
              {promo.description ||
              `Book online today and get ${discountLabel} on your skip bin hire.`}
            </p>
            {promo.end_date && (
              <span className="promo-end-date">Offer ends on {endDate}</span>
            )}
            <NavLink to="/booking" className="promo-btn">
              BOOK NOW &amp; SAVE
            </NavLink>
          </div>
        )}

        {/* Right Card - Regular Pickups */}
        <div className="promo-card pickup-card">
          <div className="pickup-content">
            <h2>Need Regular Pickups?</h2>
            <p>
              Ask about our long-term hire and commercial rates.
            </p>
            <NavLink to="/commercial" className="quote-btnn">
              GET A QUOTE
            </NavLink>
          </div>
          <div className="pickup-image">
            <img src={truckImg} alt="Skip Bin Pickup Truck" />
          </div>
        </div>
      </div>
    </section>
  );
};